// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"332":"instructions","641":"minasidor"}[chunkId] + "-legacy." + {"332":"8f47acb0","641":"75dc24ea"}[chunkId] + ".js";
};